// Shared pantry products — used by Shop page and the "Shop the Recipe" widget.
// `icon` maps to a lucide-react icon name (see productIcon helper below).
export const PRODUCTS = [
  {
    slug: "silver-swan-soy-sauce",
    brand: "Silver Swan",
    name: "Filipino Soy Sauce",
    origin: "Philippines",
    icon: "Droplet",
    tagline: "The soy sauce your adobo actually wants",
    note: "Lighter and less salty than Chinese light soy — the tang lets the vinegar in adobo speak. Nothing else works quite the same.",
    accent: "hsl(210, 40%, 25%)",
    link: "https://amzn.to/4gNsMlG",
    used_in: "chicken-adobo",
  },
  {
    slug: "rufina-patis",
    brand: "Rufina",
    name: "Patis (Fish Sauce)",
    origin: "Philippines",
    icon: "Fish",
    tagline: "Funk that finishes a dish, not overwhelms it",
    note: "Cleaner and more savoury than Southeast Asian fish sauces — a few drops turn any braise into something with a spine.",
    accent: "hsl(38, 55%, 35%)",
    link: "https://amzn.to/3TeksBy",
  },
  {
    slug: "datu-puti-vinegar",
    brand: "Datu Puti",
    name: "Cane Vinegar",
    origin: "Philippines",
    icon: "Droplets",
    tagline: "The sour that cuts through anything",
    note: "Sharper than white vinegar, mellower than rice — the exact acidity that makes adobo, kinilaw, and sawsawan sing.",
    accent: "hsl(0, 60%, 40%)",
    link: "https://amzn.to/4gS12fL",
    used_in: "chicken-adobo",
  },
  {
    slug: "shirakiku-white-miso",
    brand: "Shirakiku",
    name: "Shiro Miso Paste",
    origin: "Japan",
    icon: "Package",
    tagline: "White miso worth the fridge shelf",
    note: "Mild, sweet, and reliable. Perfect for glazes, dressings, and a five-minute soup that tastes like patience.",
    accent: "hsl(45, 45%, 55%)",
    link: "https://amzn.to/4wVxEde",
    used_in: "black-cod-miso",
  },
  {
    slug: "52usa-bay-leaves",
    brand: "52USA",
    name: "Whole Bay Leaves",
    origin: "Mediterranean",
    icon: "Leaf",
    tagline: "Two leaves in, everything tastes intentional",
    note: "The quiet aromatic in every long braise. Adobo without bay leaves is soup. With them, it's a dish.",
    accent: "hsl(90, 30%, 30%)",
    link: "https://amzn.to/4vxsO4B",
    used_in: "chicken-adobo",
  },
  {
    slug: "tellicherry-peppercorns",
    brand: "Amazon Grocery",
    name: "Tellicherry Whole Black Peppercorns",
    origin: "Malabar Coast, India",
    icon: "CircleDot",
    tagline: "The pepper you crack fresh — every time",
    note: "Larger and more aromatic than standard black pepper. If your grinder isn't full of these, your grinder isn't paying attention.",
    accent: "hsl(20, 20%, 20%)",
    link: "https://amzn.to/4wT2J16",
    used_in: "chicken-adobo",
  },
  {
    slug: "kadoya-sesame-oil",
    brand: "Kadoya",
    name: "Roasted Sesame Oil",
    origin: "Japan",
    icon: "Droplet",
    tagline: "A quarter teaspoon finishes almost anything",
    note: "Nutty, deep, unmistakable. Never for high-heat cooking — a drizzle at the very end is the whole point.",
    accent: "hsl(30, 55%, 30%)",
    link: "https://amzn.to/4wczKoT",
  },
  {
    slug: "maggi-seasoning",
    brand: "Maggi",
    name: "Seasoning Sauce",
    origin: "Switzerland / Global",
    icon: "FlaskConical",
    tagline: "The umami shortcut every grandmother hides",
    note: "A few drops deepen soups, marinades, and fried rice in a way soy sauce alone can't. Wheat-forward, meaty, and quietly essential.",
    accent: "hsl(45, 80%, 38%)",
    link: "https://amzn.to/4wdD7vO",
    upcoming: true,
  },
  {
    slug: "kewpie-mayo",
    brand: "Kewpie",
    name: "Japanese Mayonnaise",
    origin: "Japan",
    icon: "Egg",
    tagline: "Yolk-heavy, tangy, and impossible to imitate",
    note: "Rice vinegar instead of distilled, and only egg yolks — richer, silkier, sharper. Once you switch, ordinary mayo tastes like paste.",
    accent: "hsl(355, 68%, 45%)",
    link: "https://amzn.to/4wJHhLY",
    upcoming: true,
  },
  {
    slug: "diamond-crystal-salt",
    brand: "Diamond Crystal",
    name: "Kosher Salt",
    origin: "USA",
    icon: "Snowflake",
    tagline: "The salt every cookbook actually means",
    note: "Light, hollow flakes that dissolve on contact and never over-season. If a recipe just says 'kosher salt,' this is the one it means.",
    accent: "hsl(0, 65%, 42%)",
    link: "https://amzn.to/4wdDias",
    used_in: "chicken-adobo",
  },
  {
    slug: "badia-annatto",
    brand: "Badia",
    name: "Ground Annatto",
    origin: "Latin America",
    icon: "Sparkles",
    tagline: "The colour of chicken adobo you remember",
    note: "Earthy, faintly peppery, and the reason certain rice and stews glow orange-red. A pinch does what saffron pretends to.",
    accent: "hsl(18, 78%, 42%)",
    link: "https://amzn.to/3ROdXFb",
    upcoming: true,
  },
  {
    slug: "bulldog-tonkatsu-sauce",
    brand: "Bull-Dog",
    name: "Tonkatsu Sauce",
    origin: "Japan",
    icon: "Droplets",
    tagline: "Sweet, tangy, fruit-dark — the katsu companion",
    note: "Somewhere between Worcestershire and a fruit chutney. Made for fried pork cutlets, but quietly great on burgers, eggs, and rice bowls.",
    accent: "hsl(25, 45%, 22%)",
    link: "https://amzn.to/3R3WdWd",
    upcoming: true,
  },
];

export function productsForRecipe(recipeSlug) {
  return PRODUCTS.filter((p) => p.used_in === recipeSlug);
}
